export const formBasicTab = 'BASIC_DATA'; //prvi tab

export const formComponents = {
  COMP_COMPILATION: 'CompCompilation',
  COMP_NEW_COMPOSITION: 'CompNewComposition',
};
